import { motion } from "framer-motion";
import { Check, ArrowUpRight } from "lucide-react";
import { useAuth } from "@/lib/auth";
import { APPS } from "@/lib/apps";
import { ease } from "@/lib/scroll";
import { Reveal } from "@/components/temple/Reveal";
import CheckoutCard from "@/components/temple/CheckoutCard";

const PARTS = [
  ["I", "Orgasmic Field Theory and Quantum Somatics"],
  ["II", "Remote Quantum Intimacy Protocols"],
  ["III", "Female Bio-Conduction and Mirror-Currents"],
  ["IV", "Multi-Portal Convergence and the Energetic Trinity"],
  ["V", "The Transcendent Gates and Embodied Enlightenment"],
];
const INCLUDED = [
  "All ten chapters of Book II, with every solo and partnered protocol",
  "Troubleshooting, nervous-system calibration and journal prompts for each chapter",
  "Goddess Ariel as your guide inside the app, with her spoken voice",
  "The Ankhing Breath walkthrough and the complete glossary",
  "Its own private app on your phone — one payment, no subscription",
];

// /initiate?product=quantum — the Quantum Intimacy offer.
export default function QuantumOffer() {
  const { user } = useAuth();
  const app = APPS.quantum;
  if (user?.quantum) {
    return (
      <main data-testid="quantum-offer-owned" className="min-h-[80vh] flex items-center justify-center px-5 pt-28 pb-20 text-center">
        <div>
          <img src="/quantum-icon-512.png" alt="" className="mx-auto w-24 h-24 rounded-[22%]" />
          <h1 className="font-display text-5xl sm:text-6xl mt-8">Quantum Intimacy is <em className="text-[#E8838E]">yours.</em></h1>
          <a href={app.base} data-testid="quantum-offer-open" className="mt-10 inline-flex items-center gap-2 rounded-full bg-[#D9B47A] text-[#0A0706] px-7 py-4 font-tt-mono text-[12px] uppercase tracking-[0.2em]">Open the app <ArrowUpRight className="w-4 h-4" /></a>
        </div>
      </main>
    );
  }
  return (
    <main data-testid="quantum-offer" className="max-w-[1440px] mx-auto px-5 sm:px-10 pt-32 sm:pt-40 pb-28 grid lg:grid-cols-12 gap-16">
      <div className="lg:col-span-6">
        <div className="flex items-center gap-4">
          <img src="/quantum-icon-192.png" alt="" className="w-14 h-14 rounded-[22%]" />
          <p className="font-tt-mono text-[12px] uppercase tracking-[0.35em] text-[#E8838E]">The second app</p>
        </div>
        <h1 className="font-display text-[clamp(3rem,7vw,6.5rem)] leading-[0.95] mt-8">
          {["Quantum", "Intimacy."].map((w, k) => (
            <span key={w} className="block pb-[0.06em]">
              <motion.span className={`block ${k ? "italic text-[#E8838E]" : ""}`} initial={{ y: 28, opacity: 0.35 }} animate={{ y: 0, opacity: 1 }} transition={{ duration: 1.2, delay: 0.1 + k * 0.12, ease }}>{w}</motion.span>
            </span>
          ))}
        </h1>
        <p className="mt-8 text-lg text-[#CFC2B6] max-w-xl leading-relaxed">Building on the 13 Gates to Ecstasy, Book II carries you beyond physical touch into the living orgasmic field: fascial conductivity, remote field coupling, mirror-currents and the Triadic Gateways.</p>
        <Reveal className="mt-10 space-y-4">
          {INCLUDED.map((t) => (
            <p key={t} className="flex gap-4 text-[#DCCFC3]"><Check className="w-5 h-5 text-[#E8838E] shrink-0 mt-0.5" />{t}</p>
          ))}
        </Reveal>
        <ol className="mt-12 border-t border-[#D9B47A]/15">
          {PARTS.map(([n, t]) => (
            <li key={n} className="flex items-baseline gap-5 py-4 border-b border-[#D9B47A]/15">
              <span className="font-tt-mono text-[12px] text-[#D9B47A] w-8 shrink-0">{n}</span>
              <span className="font-display text-xl">{t}</span>
            </li>
          ))}
        </ol>
      </div>
      <div className="lg:col-span-5 lg:col-start-8">
        <CheckoutCard product="quantum" already={app.base} />
      </div>
    </main>
  );
}
